import React from "react";
export const MagnifyIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2034 10.1849C16.2034 13.5087 13.5089 16.2033 10.1851 16.2033C6.86121 16.2033 4.16669 13.5087 4.16669 10.1849C4.16669 6.86102 6.86121 4.1665 10.1851 4.1665C13.5089 4.1665 16.2034 6.86102 16.2034 10.1849Z"
      stroke="#808192"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3329 18.3326L15.6033 15.603"
      stroke="#808192"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
